import * as React from 'react';
import * as styles from './styles.css';

interface ILayoutProps extends React.PropsWithChildren {
  dataTestId?: string;
  stretch?: boolean;
}

export const Layout: React.FC<ILayoutProps> = ({ children, dataTestId, stretch }) => {
  return (
    <div className={stretch ? styles['stretch'] : styles['container']} data-testid={dataTestId}>
      {children}
    </div>
  );
};
